export default __webpack_public_path__ + "static/media/sustentabilidade5.e8b62afd.jpg";